import { initializeApp } from 'firebase/app';
import {
  getAuth,
  signInWithPopup as fbSignInWithPopup,
  GoogleAuthProvider,
  onAuthStateChanged as fbOnAuthStateChanged,
  signOut as fbSignOut,
} from 'firebase/auth';

// Runtime config (injected by docker-entrypoint.sh) takes priority over build-time env vars
const runtimeCfg = window.__FIREBASE_CONFIG__ || {};
const firebaseConfig = {
  apiKey: runtimeCfg.apiKey || import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: runtimeCfg.authDomain || import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: runtimeCfg.projectId || import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: runtimeCfg.storageBucket || import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: runtimeCfg.messagingSenderId || import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: runtimeCfg.appId || import.meta.env.VITE_FIREBASE_APP_ID,
};

export const hasFirebaseConfig = !!firebaseConfig.apiKey;

let auth;
let googleProvider;
let signInWithPopup;
let onAuthStateChanged;
let signOut;

if (hasFirebaseConfig) {
  const app = initializeApp(firebaseConfig);
  auth = getAuth(app);
  googleProvider = new GoogleAuthProvider();
  signInWithPopup = fbSignInWithPopup;
  onAuthStateChanged = fbOnAuthStateChanged;
  signOut = fbSignOut;
} else {
  // Firebase not configured — provide stubs for test-login-only mode
  console.info('[firebase] No API key configured — running in test-login-only mode');
  auth = { currentUser: null };
  googleProvider = null;
  signInWithPopup = () => Promise.reject(new Error('Firebase not configured'));
  onAuthStateChanged = (_auth, callback) => {
    // Immediately signal "no Firebase user" so useAuth falls through to test-login check
    setTimeout(() => callback(null), 0);
    return () => {};
  };
  signOut = () => Promise.resolve();
}

export {
  auth,
  googleProvider,
  signInWithPopup,
  onAuthStateChanged,
  signOut,
};
